import { Screen, Platform } from 'quasar'

export const isMobile = () => {
  return Screen.lt.sm
}
export const isTablet = () => {
  return Screen.gt.xs && Screen.lt.lg
}
export const isDesktop = () => {
  return Screen.gt.md
}
export const isPrint = () => {
  return window.matchMedia('print').matches
}
export const hasTouch = () => {
  return Platform.has.touch
}


export default {
  computed: {
    $isMobile: isMobile,
    $isTablet: isTablet,
    $isDesktop: isDesktop,
    $isPrint: isPrint,
    $hasTouch: hasTouch,
  },
  methods: {
    $cssProperty (name) {
      const style = window.getComputedStyle(this.$el)
      return style.getPropertyValue(name).trim()
    },
  },
}
